import { useEffect } from 'react';

import { useAppConfig } from 'src/config/appConfig';
import { parseCookies } from 'src/modules/safe-cookies';
import { locationChanged } from 'src/store/location';
import { useDispatch, useSelector } from 'src/store/react';
import { getRecentSearches } from 'src/store/recentSearches';
import {
  persistCriteriaLocally,
  updateCriteria,
  updateKeywordsField,
} from 'src/store/search';
import { replaceKeywordsSlugPath } from 'src/utils/urlKeywordsSlug';

export const useSQCKeywordFieldUpdate = ({
  isQueryModified = false,
  searchExecutedKeywords,
}: {
  isQueryModified?: boolean;
  searchExecutedKeywords?: string;
}) => {
  const { country } = useAppConfig();
  const dispatch = useDispatch();
  const zone = useSelector((state) => state.appConfig.zone);

  useEffect(() => {
    if (isQueryModified && searchExecutedKeywords) {
      dispatch(updateKeywordsField(searchExecutedKeywords));

      const keywordId = document.getElementById('keywords-input');
      if (keywordId) {
        keywordId.blur();
      }
      // Update URL with corrected keywords
      const currentUrl = window.location.pathname;
      const newPath = replaceKeywordsSlugPath(
        currentUrl,
        searchExecutedKeywords,
      );
      if (currentUrl !== newPath) {
        window.history.replaceState({}, '', newPath);
      }
      // Update search criteria in the store with corrected keywords
      dispatch(updateCriteria({ path: newPath, zone }));
      // Update for analytics
      dispatch(locationChanged(window.location.href, location));

      dispatch(persistCriteriaLocally(true));
      dispatch(getRecentSearches({ cookies: parseCookies(), country }));
    }
  }, [isQueryModified, searchExecutedKeywords, dispatch, zone, country]);
};
